
@if (show){
    <div class="sx-carousel-display" id="carousel-display" >
        <div class="sx-carousel-display__item" id="carousel-display_items">
            @for(slide of slides; track slide.id; let i = $index;){
                <div>
                    @if(i === currentIndex){
                        <label> 
                            <div class="sx-carousel-display__item--content sxh-flex" @carouselAnimation>
                                <div class="sx-carousel-display__item--content-left">
                                    <div>
                                        <h4 [ngClass]="{'sx-message__item-title--unread': !slide.isRead}">
                                            {{slide.title}}
                                            @if(!slide.isRead){
                                                <span class="sx-carousel-display__badge">
                                                    {{'core.carousel.not-read'|translate}}
                                                </span>
                                            }
                                        </h4>
                                        @if(slide.content){
                                            <div [innerHtml]="slide.content | safeHtml" appRouterLink setInformationAsRead id="{{slide.id}}"></div>   
                                        }
                                    </div>
                                </div>
                                <div class="sx-carousel-display__item--content-right">
                                    @if(slide.imageUrl && !slide.videoUrl){
                                        <div class="sx-carousel-display__item--imagewrapper">
                                            <img src="{{slide.imageUrl}}"/>
                                        </div>
                                    }
                                    @if(slide.videoUrl){
                                        <div class="sx-carousel-display__item--imagewrapper">
                                            <iframe credentialless id="Iframe" [src]="slide.videoUrl|safeResourceUrl" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                                        </div>
                                    }
                                </div>
                            </div >
                        </label>
                    }
                </div>
            }
        </div>
        <!-- Next and Prevoius buttons on Mobile.  Dots for selecting page/slide -->
        <div class="sx-carousel-display__dots-container">
            <button class="sx-carousel-display__dots--button prev" (click)="onPreviousClick(slides[currentIndex]?.id)" [disabled]="currentIndex==0">
                <div class="sx-link-banner__icon-container sxl-flex">
                    <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                        <span class="sx-link-banner__icon"><svg><use xlink:href="#sx-chevron_left" href="#sx-chevron_left"></use></svg></span>
                        <span class="sx-carousel-display__dots--text">{{slides[currentIndex-1]?.title}}</span>
                    </div>
                </div>
            </button>
            <div class="dots">
                @for(slide of slides; track slide.id; let slideIndex = $index){
                    <div class="dot"
                        [ngClass]="{'dot-selected': slideIndex == currentIndex}" 
                        (click)="onSlideClick(slideIndex, slides[currentIndex]?.id)">
                    </div>
                }
            </div>

            <button class="sx-carousel-display__dots--button next" (click)="onNextClick(slides[currentIndex]?.id)" [disabled]="currentIndex==slides.length-1">
                <div class="sx-link-banner__icon-container sxl-flex">
                    <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                        <span class="sx-carousel-display__dots--text">{{slides[currentIndex+1]?.title}}</span>
                        <span class="sx-link-banner__icon"><svg><use xlink:href="#sx-chevron_right" href="#sx-chevron_right"></use></svg></span>
                    </div>
                </div>
            </button>
        </div>
    </div>
}

